import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { defaultRelatedTables } from "../../config/defaultRelatedTables";
import {
  fullWidth,
  halfWidth,
  thirdWidth,
} from "../../blocks/layout/columnSpans";

/** The Account page's shipped layout, laid out as the Contact page is. */
export const accountPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "account",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 12, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-account-details",
              title: "Account Details",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: thirdWidth,
                },
                {
                  id: "field-emailaddress1",
                  type: "email",
                  name: "emailaddress1",
                  label: "Email Address",
                  span: thirdWidth,
                },
                {
                  id: "field-telephone1",
                  type: "text",
                  name: "telephone1",
                  label: "Business Phone",
                  span: thirdWidth,
                },
                {
                  id: "field-description",
                  type: "longtext",
                  name: "description",
                  label: "Description",
                  rows: 4,
                  span: fullWidth,
                },
              ],
            },
            {
              kind: "section",
              id: "section-primary-address",
              title: "Primary Address",
              helperText: "The account's main address.",
              fields: [
                {
                  id: "field-address1_line1",
                  type: "text",
                  name: "address1_line1",
                  label: "Line 1",
                  span: thirdWidth,
                },
                {
                  id: "field-address1_line2",
                  type: "text",
                  name: "address1_line2",
                  label: "Line 2",
                  span: thirdWidth,
                },
                {
                  id: "field-address1_city",
                  type: "text",
                  name: "address1_city",
                  label: "City",
                  span: thirdWidth,
                },
                {
                  id: "field-address1_county",
                  type: "text",
                  name: "address1_county",
                  label: "County",
                  span: thirdWidth,
                },
                {
                  id: "field-address1_country",
                  type: "text",
                  name: "address1_country",
                  label: "Country",
                  span: thirdWidth,
                },
                {
                  id: "field-address1_postalcode",
                  type: "text",
                  name: "address1_postalcode",
                  label: "Postal Code",
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 12, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-marketing-preferences",
              title: "Marketing Preferences",
              helperText: "Controls what this account receives from the club.",
              // The account flags contact's preferences also use; contact's SMS and
              // partner flags aren't account columns.
              fields: [
                {
                  id: "field-donotbulkemail",
                  type: "boolean",
                  name: "donotbulkemail",
                  label: "Send Email",
                  span: halfWidth,
                },
                {
                  id: "field-donotbulkpostalmail",
                  type: "boolean",
                  name: "donotbulkpostalmail",
                  label: "Send Postal Mail",
                  span: halfWidth,
                },
                {
                  id: "field-donotphone",
                  type: "boolean",
                  name: "donotphone",
                  label: "Send Phone Calls",
                  span: halfWidth,
                },
              ],
            },
            {
              kind: "section",
              id: "section-website",
              title: "Website",
              fields: [
                {
                  id: "field-websiteurl",
                  type: "text",
                  name: "websiteurl",
                  label: "Website URL",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "row-tables",
      columns: [
        {
          id: "column-tables",
          span: fullWidth,
          blocks: [
            {
              kind: "tables",
              id: "block-related-tables",
              tabs: defaultRelatedTables.account,
            },
          ],
        },
      ],
    },
  ],
};
